import { Field } from "enums";
import Validation from "services/validation.service";
import lang from "translations";
import { parseMoneyToNumber } from "services/money.service";

// SVEMS-774. Validation.rangeValue cannot express this rule: it parses the field through
// parseMoneyToNumber, which turns an empty string into 0, so rangeValue(1, 100) would
// reject a blank field. Blank has to stay valid — BE treats null and 0 alike as "no
// discount" — while anything actually typed has to be a real discount of 1-100, which
// also rules out a literal 0.
const validateProfileDiscount = (field) => {
  const typed = `${field.value ?? ""}`.trim();
  if (!typed) {
    return { error: false, message: null };
  }
  const discount = parseMoneyToNumber(typed).value;
  if (!Number.isFinite(discount) || discount < 1 || discount > 100) {
    return { error: true, message: lang.profileDiscountRange };
  }
  return { error: false, message: null };
};

const initialFormState = (initialState = {}) => {
  const {
    name = "",
    description = "",
    amount = 0,
    isAllowedPostLimit = false,
    limit = 0,
    freeCredit = 0,
    isAskQuestion = false,
    questions = {},
    vouchers = [],
    customQuestionsRequired = {},
    sortQuestions = [],
    customQuestionIncludes = {},
    defaultQuestionIncludes = {},
    isTagRegistration = false,
    eatAppRoomId = undefined,
    profileDiscount = "",
  } = initialState;
  return {
    name: {
      name: "name",
      value: name,
      type: Field.INPUT,
      validations: [Validation.required()],
      required: true,
      maxLength: 75,
      label: lang.profileName,
      placeholder: lang.guestProfileNamePlaceholder,
    },
    description: {
      name: "description",
      value: description || "",
      type: Field.INPUT,
      validations: [Validation.maxlength(255)],
      maxLength: 255,
      label: lang.description,
      placeholder: lang.guestProfileDescriptionPlaceholder,
    },
    amount: {
      name: "amount",
      description: lang.theAmountTheGuestWillPay,
      value: amount,
      type: Field.INPUT,
      label: lang.bookingPrice,
      placeholder: lang.guestProfileAmountPlaceholder,
    },
    isAllowedPostLimit: {
      name: "isAllowedPostLimit",
      value: isAllowedPostLimit,
      type: Field.CHECKBOX,
      label: lang.allowPostpaidInGuestProfile,
    },
    freeCredit: {
      name: "freeCredit",
      value: freeCredit,
      type: Field.INPUT,
    },
    limit: {
      name: "limit",
      value: limit,
      type: Field.INPUT,
    },
    isAskQuestion: {
      name: "isAskQuestion",
      value: isAskQuestion,
      type: Field.CHECKBOX,
    },
    customQuestionsRequired: {
      name: "customQuestionsRequired",
      value: customQuestionsRequired,
      type: Field.ANY,
    },
    questions: {
      name: "questions",
      value: {
        firstNameRequired: {
          checked: true,
        },
        lastNameRequired: {
          checked: true,
        },
        ...questions,
      },
      type: Field.ANY,
    },
    defaultQuestionIncludes: {
      name: "defaultQuestionIncludes",
      value: {
        firstNameIncluded: {
          checked: true,
        },
        lastNameIncluded: {
          checked: true,
        },
        ...defaultQuestionIncludes,
      },
      type: Field.ANY,
    },
    sortQuestions: {
      name: "sortQuestions",
      value: sortQuestions,
      type: Field.ANY,
    },
    vouchers: {
      name: "vouchers",
      value: vouchers,
      type: Field.ANY,
    },
    customQuestionIncludes: {
      name: "customQuestionIncludes",
      value: customQuestionIncludes,
      type: Field.ANY,
    },
    isTagRegistration: {
      name: "isTagRegistration",
      value: isTagRegistration,
      type: Field.CHECKBOX,
      label: lang.allowNonNfcActivationProfile,
    },
    eatAppRoomId: {
      name: "eatAppRoomId",
      value: eatAppRoomId,
      type: Field.INPUT,
      label: lang.eatAppId,
      placeholder: lang.eatAppIdPlaceholder,
    },
    profileDiscount: {
      name: "profileDiscount",
      value: profileDiscount,
      type: Field.INPUT,
      // Not required: an empty field means no discount, which is submitted as 0.
      // Validation.number stays so that typed rubbish gets "should be a number" rather than
      // the range message; it passes a blank field, which parses to 0 and not to NaN.
      validations: [Validation.number(), validateProfileDiscount],
      label: lang.profileDiscount,
    },
  };
};

export default initialFormState;
